import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AbbinatoreV2Layout from './AbbinatoreV2Layout';
import DashboardSection from './sections/DashboardSection';
import MacchineSection from './sections/MacchineSection';
import CompatibilitaView from './sections/CompatibilitaView';
import ArticoliSection from './sections/ArticoliSection';
import AbbinamentoSection from './sections/AbbinamentoSection';
import ImportExportSection from './sections/ImportExportSection';

export default function AbbinatoreV2Routes() {
  return (
    <Routes>
      <Route element={<AbbinatoreV2Layout />}>
        <Route index element={<DashboardSection />} />
        <Route path="macchine" element={<MacchineSection />} />
        <Route path="compatibilita" element={<CompatibilitaView />} />
        <Route path="articoli" element={<ArticoliSection />} />
        <Route path="abbinamento" element={<AbbinamentoSection />} />
        <Route path="import-export" element={<ImportExportSection />} />
        {/* Route rimosse (es. "esclusioni") o sconosciute → torna alla dashboard */}
        <Route path="*" element={<Navigate to="/admin/abbinatore-v2" replace />} />
      </Route>
    </Routes>
  );
}

